window.theme = window.theme || {};

/**
 * @license
 * Lodash (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash core -o ./dist/lodash.core.js`
 */
;(function(){function n(n){return H(n)&&pn.call(n,"callee")&&!yn.call(n,"callee")}function t(n,t){return n.push.apply(n,t),n}function r(n){return function(t){return null==t?Z:t[n]}}function e(n,t,r,e,u){return u(n,function(n,u,o){r=e?(e=false,n):t(r,n,u,o)}),r}function u(n,t){return j(t,function(t){return n[t]})}function o(n){return n instanceof i?n:new i(n)}function i(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t}function c(n,t,r){if(typeof n!="function")throw new TypeError("Expected a function");
return setTimeout(function(){n.apply(Z,r)},t)}function f(n,t){var r=true;return mn(n,function(n,e,u){return r=!!t(n,e,u)}),r}function a(n,t,r){for(var e=-1,u=n.length;++e<u;){var o=n[e],i=t(o);if(null!=i&&(c===Z?i===i:r(i,c)))var c=i,f=o}return f}function l(n,t){var r=[];return mn(n,function(n,e,u){t(n,e,u)&&r.push(n)}),r}function p(n,r,e,u,o){var i=-1,c=n.length;for(e||(e=R),o||(o=[]);++i<c;){var f=n[i];0<r&&e(f)?1<r?p(f,r-1,e,u,o):t(o,f):u||(o[o.length]=f)}return o}function s(n,t){return n&&On(n,t,Dn);
}function h(n,t){return l(t,function(t){return U(n[t])})}function v(n,t){return n>t}function b(n,t,r,e,u){return n===t||(null==n||null==t||!H(n)&&!H(t)?n!==n&&t!==t:y(n,t,r,e,b,u))}function y(n,t,r,e,u,o){var i=Nn(n),c=Nn(t),f=i?"[object Array]":hn.call(n),a=c?"[object Array]":hn.call(t),f="[object Arguments]"==f?"[object Object]":f,a="[object Arguments]"==a?"[object Object]":a,l="[object Object]"==f,c="[object Object]"==a,a=f==a;o||(o=[]);var p=An(o,function(t){return t[0]==n}),s=An(o,function(n){
return n[0]==t});if(p&&s)return p[1]==t;if(o.push([n,t]),o.push([t,n]),a&&!l){if(i)r=T(n,t,r,e,u,o);else n:{switch(f){case"[object Boolean]":case"[object Date]":case"[object Number]":r=J(+n,+t);break n;case"[object Error]":r=n.name==t.name&&n.message==t.message;break n;case"[object RegExp]":case"[object String]":r=n==t+"";break n}r=false}return o.pop(),r}return 1&r||(i=l&&pn.call(n,"__wrapped__"),f=c&&pn.call(t,"__wrapped__"),!i&&!f)?!!a&&(r=B(n,t,r,e,u,o),o.pop(),r):(i=i?n.value():n,f=f?t.value():t,
r=u(i,f,r,e,o),o.pop(),r)}function g(n){return typeof n=="function"?n:null==n?X:(typeof n=="object"?d:r)(n)}function _(n,t){return n<t}function j(n,t){var r=-1,e=M(n)?Array(n.length):[];return mn(n,function(n,u,o){e[++r]=t(n,u,o)}),e}function d(n){var t=_n(n);return function(r){var e=t.length;if(null==r)return!e;for(r=Object(r);e--;){var u=t[e];if(!(u in r&&b(n[u],r[u],3)))return false}return true}}function m(n,t){return n=Object(n),C(t,function(t,r){return r in n&&(t[r]=n[r]),t},{})}function O(n){return xn(I(n,void 0,X),n+"");
}function x(n,t,r){var e=-1,u=n.length;for(0>t&&(t=-t>u?0:u+t),r=r>u?u:r,0>r&&(r+=u),u=t>r?0:r-t>>>0,t>>>=0,r=Array(u);++e<u;)r[e]=n[e+t];return r}function A(n){return x(n,0,n.length)}function E(n,t){var r;return mn(n,function(n,e,u){return r=t(n,e,u),!r}),!!r}function w(n,r){return C(r,function(n,r){return r.func.apply(r.thisArg,t([n],r.args))},n)}function k(n,t,r){var e=!r;r||(r={});for(var u=-1,o=t.length;++u<o;){var i=t[u],c=Z;if(c===Z&&(c=n[i]),e)r[i]=c;else{var f=r,a=f[i];pn.call(f,i)&&J(a,c)&&(c!==Z||i in f)||(f[i]=c);
}}return r}function N(n){return O(function(t,r){var e=-1,u=r.length,o=1<u?r[u-1]:Z,o=3<n.length&&typeof o=="function"?(u--,o):Z;for(t=Object(t);++e<u;){var i=r[e];i&&n(t,i,e,o)}return t})}function F(n){return function(){var t=arguments,r=dn(n.prototype),t=n.apply(r,t);return V(t)?t:r}}function S(n,t,r){function e(){for(var o=-1,i=arguments.length,c=-1,f=r.length,a=Array(f+i),l=this&&this!==on&&this instanceof e?u:n;++c<f;)a[c]=r[c];for(;i--;)a[c++]=arguments[++o];return l.apply(t,a)}if(typeof n!="function")throw new TypeError("Expected a function");
var u=F(n);return e}function T(n,t,r,e,u,o){var i=n.length,c=t.length;if(i!=c&&!(1&r&&c>i))return false;for(var c=-1,f=true,a=2&r?[]:Z;++c<i;){var l=n[c],p=t[c];if(void 0!==Z){f=false;break}if(a){if(!E(t,function(n,t){if(!P(a,t)&&(l===n||u(l,n,r,e,o)))return a.push(t)})){f=false;break}}else if(l!==p&&!u(l,p,r,e,o)){f=false;break}}return f}function B(n,t,r,e,u,o){var i=1&r,c=Dn(n),f=c.length,a=Dn(t).length;if(f!=a&&!i)return false;for(var l=f;l--;){var p=c[l];if(!(i?p in t:pn.call(t,p)))return false}for(a=true;++l<f;){var p=c[l],s=n[p],h=t[p];
if(void 0!==Z||s!==h&&!u(s,h,r,e,o)){a=false;break}i||(i="constructor"==p)}return a&&!i&&(r=n.constructor,e=t.constructor,r!=e&&"constructor"in n&&"constructor"in t&&!(typeof r=="function"&&r instanceof r&&typeof e=="function"&&e instanceof e)&&(a=false)),a}function R(t){return Nn(t)||n(t)}function D(n){var t=[];if(null!=n)for(var r in Object(n))t.push(r);return t}function I(n,t,r){return t=jn(t===Z?n.length-1:t,0),function(){for(var e=arguments,u=-1,o=jn(e.length-t,0),i=Array(o);++u<o;)i[u]=e[t+u];for(u=-1,
o=Array(t+1);++u<t;)o[u]=e[u];return o[t]=r(i),n.apply(this,o)}}function $(n){return(null==n?0:n.length)?p(n,1):[]}function q(n){return n&&n.length?n[0]:Z}function P(n,t,r){var e=null==n?0:n.length;r=typeof r=="number"?0>r?jn(e+r,0):r:0,r=(r||0)-1;for(var u=t===t;++r<e;){var o=n[r];if(u?o===t:o!==o)return r}return-1}function z(n,t){return mn(n,g(t))}function C(n,t,r){return e(n,g(t),r,3>arguments.length,mn)}function G(n,t){var r;if(typeof t!="function")throw new TypeError("Expected a function");return n=Fn(n),
function(){return 0<--n&&(r=t.apply(this,arguments)),1>=n&&(t=Z),r}}function J(n,t){return n===t||n!==n&&t!==t}function M(n){var t;return(t=null!=n)&&(t=n.length,t=typeof t=="number"&&-1<t&&0==t%1&&9007199254740991>=t),t&&!U(n)}function U(n){return!!V(n)&&(n=hn.call(n),"[object Function]"==n||"[object GeneratorFunction]"==n||"[object AsyncFunction]"==n||"[object Proxy]"==n)}function V(n){var t=typeof n;return null!=n&&("object"==t||"function"==t)}function H(n){return null!=n&&typeof n=="object"}function K(n){
return typeof n=="number"||H(n)&&"[object Number]"==hn.call(n)}function L(n){return typeof n=="string"||!Nn(n)&&H(n)&&"[object String]"==hn.call(n)}function Q(n){return typeof n=="string"?n:null==n?"":n+""}function W(n){return null==n?[]:u(n,Dn(n))}function X(n){return n}function Y(n,r,e){var u=Dn(r),o=h(r,u);null!=e||V(r)&&(o.length||!u.length)||(e=r,r=n,n=this,o=h(r,Dn(r)));var i=!(V(e)&&"chain"in e&&!e.chain),c=U(n);return mn(o,function(e){var u=r[e];n[e]=u,c&&(n.prototype[e]=function(){var r=this.__chain__;
if(i||r){var e=n(this.__wrapped__);return(e.__actions__=A(this.__actions__)).push({func:u,args:arguments,thisArg:n}),e.__chain__=r,e}return u.apply(n,t([this.value()],arguments))})}),n}var Z,nn=1/0,tn=/[&<>"']/g,rn=RegExp(tn.source),en=/^(?:0|[1-9]\d*)$/,un=typeof self=="object"&&self&&self.Object===Object&&self,on=typeof global=="object"&&global&&global.Object===Object&&global||un||Function("return this")(),cn=(un=typeof exports=="object"&&exports&&!exports.nodeType&&exports)&&typeof module=="object"&&module&&!module.nodeType&&module,fn=function(n){
return function(t){return null==n?Z:n[t]}}({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}),an=Array.prototype,ln=Object.prototype,pn=ln.hasOwnProperty,sn=0,hn=ln.toString,vn=on._,bn=Object.create,yn=ln.propertyIsEnumerable,gn=on.isFinite,_n=function(n,t){return function(r){return n(t(r))}}(Object.keys,Object),jn=Math.max,dn=function(){function n(){}return function(t){return V(t)?bn?bn(t):(n.prototype=t,t=new n,n.prototype=Z,t):{}}}();i.prototype=dn(o.prototype),i.prototype.constructor=i;
var mn=function(n,t){return function(r,e){if(null==r)return r;if(!M(r))return n(r,e);for(var u=r.length,o=t?u:-1,i=Object(r);(t?o--:++o<u)&&false!==e(i[o],o,i););return r}}(s),On=function(n){return function(t,r,e){var u=-1,o=Object(t);e=e(t);for(var i=e.length;i--;){var c=e[n?i:++u];if(false===r(o[c],c,o))break}return t}}(),xn=X,An=function(n){return function(t,r,e){var u=Object(t);if(!M(t)){var o=g(r);t=Dn(t),r=function(n){return o(u[n],n,u)}}return r=n(t,r,e),-1<r?u[o?t[r]:r]:Z}}(function(n,t,r){var e=null==n?0:n.length;
if(!e)return-1;r=null==r?0:Fn(r),0>r&&(r=jn(e+r,0));n:{for(t=g(t),e=n.length,r+=-1;++r<e;)if(t(n[r],r,n)){n=r;break n}n=-1}return n}),En=O(function(n,t,r){return S(n,t,r)}),wn=O(function(n,t){return c(n,1,t)}),kn=O(function(n,t,r){return c(n,Sn(t)||0,r)}),Nn=Array.isArray,Fn=Number,Sn=Number,Tn=N(function(n,t){k(t,_n(t),n)}),Bn=N(function(n,t){k(t,D(t),n)}),Rn=O(function(n,t){n=Object(n);var r,e=-1,u=t.length,o=2<u?t[2]:Z;if(r=o){r=t[0];var i=t[1];if(V(o)){var c=typeof i;if("number"==c){if(c=M(o))var c=o.length,f=typeof i,c=null==c?9007199254740991:c,c=!!c&&("number"==f||"symbol"!=f&&en.test(i))&&-1<i&&0==i%1&&i<c;
}else c="string"==c&&i in o;r=!!c&&J(o[i],r)}else r=false}for(r&&(u=1);++e<u;)for(o=t[e],r=In(o),i=-1,c=r.length;++i<c;){var f=r[i],a=n[f];(a===Z||J(a,ln[f])&&!pn.call(n,f))&&(n[f]=o[f])}return n}),Dn=_n,In=D,$n=function(n){return xn(I(n,Z,$),n+"")}(function(n,t){return null==n?{}:m(n,t)});o.assignIn=Bn,o.before=G,o.bind=En,o.chain=function(n){return n=o(n),n.__chain__=true,n},o.compact=function(n){return l(n,Boolean)},o.concat=function(){var n=arguments.length;if(!n)return[];for(var r=Array(n-1),e=arguments[0];n--;)r[n-1]=arguments[n];
return t(Nn(e)?A(e):[e],p(r,1))},o.create=function(n,t){var r=dn(n);return null==t?r:Tn(r,t)},o.defaults=Rn,o.defer=wn,o.delay=kn,o.filter=function(n,t){return l(n,g(t))},o.flatten=$,o.flattenDeep=function(n){return(null==n?0:n.length)?p(n,nn):[]},o.iteratee=g,o.keys=Dn,o.map=function(n,t){return j(n,g(t))},o.matches=function(n){return d(Tn({},n))},o.mixin=Y,o.negate=function(n){if(typeof n!="function")throw new TypeError("Expected a function");return function(){return!n.apply(this,arguments)}},o.once=function(n){
return G(2,n)},o.pick=$n,o.slice=function(n,t,r){var e=null==n?0:n.length;return r=r===Z?e:+r,e?x(n,null==t?0:+t,r):[]},o.sortBy=function(n,t){var e=0;return t=g(t),j(j(n,function(n,r,u){return{value:n,index:e++,criteria:t(n,r,u)}}).sort(function(n,t){var r;n:{r=n.criteria;var e=t.criteria;if(r!==e){var u=r!==Z,o=null===r,i=r===r,c=e!==Z,f=null===e,a=e===e;if(!f&&r>e||o&&c&&a||!u&&a||!i){r=1;break n}if(!o&&r<e||f&&u&&i||!c&&i||!a){r=-1;break n}}r=0}return r||n.index-t.index}),r("value"))},o.tap=function(n,t){
return t(n),n},o.thru=function(n,t){return t(n)},o.toArray=function(n){return M(n)?n.length?A(n):[]:W(n)},o.values=W,o.extend=Bn,Y(o,o),o.clone=function(n){return V(n)?Nn(n)?A(n):k(n,_n(n)):n},o.escape=function(n){return(n=Q(n))&&rn.test(n)?n.replace(tn,fn):n},o.every=function(n,t,r){return t=r?Z:t,f(n,g(t))},o.find=An,o.forEach=z,o.has=function(n,t){return null!=n&&pn.call(n,t)},o.head=q,o.identity=X,o.indexOf=P,o.isArguments=n,o.isArray=Nn,o.isBoolean=function(n){return true===n||false===n||H(n)&&"[object Boolean]"==hn.call(n);
},o.isDate=function(n){return H(n)&&"[object Date]"==hn.call(n)},o.isEmpty=function(t){return M(t)&&(Nn(t)||L(t)||U(t.splice)||n(t))?!t.length:!_n(t).length},o.isEqual=function(n,t){return b(n,t)},o.isFinite=function(n){return typeof n=="number"&&gn(n)},o.isFunction=U,o.isNaN=function(n){return K(n)&&n!=+n},o.isNull=function(n){return null===n},o.isNumber=K,o.isObject=V,o.isRegExp=function(n){return H(n)&&"[object RegExp]"==hn.call(n)},o.isString=L,o.isUndefined=function(n){return n===Z},o.last=function(n){
var t=null==n?0:n.length;return t?n[t-1]:Z},o.max=function(n){return n&&n.length?a(n,X,v):Z},o.min=function(n){return n&&n.length?a(n,X,_):Z},o.noConflict=function(){return on._===this&&(on._=vn),this},o.noop=function(){},o.reduce=C,o.result=function(n,t,r){return t=null==n?Z:n[t],t===Z&&(t=r),U(t)?t.call(n):t},o.size=function(n){return null==n?0:(n=M(n)?n:_n(n),n.length)},o.some=function(n,t,r){return t=r?Z:t,E(n,g(t))},o.uniqueId=function(n){var t=++sn;return Q(n)+t},o.each=z,o.first=q,Y(o,function(){
var n={};return s(o,function(t,r){pn.call(o.prototype,r)||(n[r]=t)}),n}(),{chain:false}),o.VERSION="4.17.15",mn("pop join replace reverse split push shift sort splice unshift".split(" "),function(n){var t=(/^(?:replace|split)$/.test(n)?String.prototype:an)[n],r=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",e=/^(?:pop|join|replace|shift)$/.test(n);o.prototype[n]=function(){var n=arguments;if(e&&!this.__chain__){var u=this.value();return t.apply(Nn(u)?u:[],n)}return this[r](function(r){return t.apply(Nn(r)?r:[],n);
})}}),o.prototype.toJSON=o.prototype.valueOf=o.prototype.value=function(){return w(this.__wrapped__,this.__actions__)},typeof define=="function"&&typeof define.amd=="object"&&define.amd?(on._=o, define(function(){return o})):cn?((cn.exports=o)._=o,un._=o):on._=o}).call(this);

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();


// Tinybind Formatters

tinybind.formatters.or = function(a, b) {
  return a || b;
};

tinybind.formatters.eq = function(a, b) {
  return a === b;
};

tinybind.formatters.ne = function(a, b) {
  return a !== b;
};

tinybind.formatters.includes = function(a, b) {
  return a.indexOf(b) >= 0;
};

tinybind.formatters.match = function(a, regexp, flags) {
  return a.match(new RegExp(regexp, flags));
};

tinybind.formatters.lt = function(a, b) {
  return a < b;
};

tinybind.formatters.gt = function(a, b) {
  return a > b;
};

tinybind.formatters.empty = function(a) {
  return (a ? !a.length : true);
};

tinybind.formatters.plus = function(a, b) {
  return parseInt(a) + parseInt(b);
};

tinybind.formatters.minus = function(a, b) {
  return parseInt(a) - parseInt(b);
};

tinybind.formatters.times = function(a, b) {
  return a * b;
};

tinybind.formatters.divided_by = function(a, b) {
  return a / b;
};

tinybind.formatters.modulo = function(a, b) {
  return a % b;
};

tinybind.formatters.prepend = function(a, b) {
  return b + a;
};

tinybind.formatters.append = function(a, b) {
  return a + b;
};

tinybind.formatters.size = function(a) {
  return _.size(a);
};

tinybind.formatters.length = tinybind.formatters.size;

tinybind.formatters.money = function(a) {
	return Shopify.formatMoney(parseInt(a), window.shopCurrencySymbol + "{{amount}}");
};

tinybind.formatters.get = function(a, b) {
  return (a && a[b]) ? a[b] : null;
};

tinybind.formatters.allPropertiesTrue = function(items, key) {
  for (var i = items.length - 1; i >= 0; i--) {
    if (!items[i][key]) {
      return false;
    }
  }

  return true;
};

tinybind.formatters.allPropertiesFalse = function(items, key) {
  for (var i = items.length - 1; i >= 0; i--) {
    if (!!items[i][key]) {
      return false;
    }
  }

  return true;
};

tinybind.formatters.handle = function(a) {
  return a.toString().toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
};

tinybind.formatters.handleize = tinybind.formatters.handle;

tinybind.formatters.log = function(value) {
  return value;
};

tinybind.formatters.img = function(image, alt, maxWidth, maxHeight) {

  if (!image) {
    return;
  }

  var imgTemplateURL,
      imgString,
      imgUrl;

  imgUrl = (typeof image == 'string' ? image : image.src);

  imgTemplateURL = theme.Image.getSizedImageUrl(imgUrl, '{width}x');

  maxWidth = maxWidth ? ((image.width ? image.width + 'px' : false) || (typeof maxWidth == 'string' ? maxWidth : maxWidth + 'px')) : 'none';
  maxHeight = maxHeight ? ((image.height ? image.height + 'px' : false) || (typeof maxHeight == 'string' ? maxHeight : maxHeight + 'px')) : 'none';

  alt = alt || null;

  imgString = '<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" class="lazyload" style="max-width: ' + maxWidth + '; max-height: ' + maxHeight + ';" data-sizes="auto" data-src="' + imgTemplateURL + '" alt="' + alt + ' "/>'

  return imgString;
};

tinybind.binders['money'] = function(el, value) {
    let price_format = window.shopCurrencySymbol + "{{amount}}";
    let formatted_price = Shopify.formatMoney(parseInt(value), price_format).replace('.00', '');
    
    if (Shopify.currency && Shopify.currency.active === 'EUR' && (Shopify.country == 'IE' || Shopify.country == 'MT')) {
      formatted_price = formatted_price.replace(',', '.');
    }else if (Shopify.currency && Shopify.currency.active === 'EUR') {
      formatted_price = formatted_price.replace('.', ',');
    }

    el.innerHTML = '<span class="money">' + formatted_price + '</span>';
    setTimeout(function() {
        if (typeof DoublyGlobalCurrency !== 'undefined' && $('[name=doubly-currencies]').length > 0) {
            DoublyGlobalCurrency.convertAll($('[name=doubly-currencies]').val());
        }
    }, 0);
};


tinybind.binders['viewbox'] = function(el, value) {
  el.setAttribute('viewBox', value);
};

tinybind.formatters.imgUrl = function(image, size) {

  if (!image) {
    return;
  }

  return theme.Image.getSizedImageUrl(image, size);
};

tinybind.binders['attr-*'] = function(el, value) {
  var attrToSet = this.type.substring(this.type.indexOf('-')+1)

  if (value || value === 0) {
    el.setAttribute(attrToSet, value);
  } else {
    el.removeAttribute(attrToSet);
  }
}
tinybind.binders.class = function(el, value) {
  if(value === true){
    el.classList.add('input-disable')
  } else {
    el.classList.remove('input-disable')
  }
}

function _initPickerSlider(){
	setTimeout(() => {
      const pickerGalleries = document.querySelectorAll('.p-custom__colors')
      
      if (!pickerGalleries.length) return;

      pickerGalleries.forEach((item) => {
        item.classList.contains('hide') ? console.log('hide') : item.querySelectorAll('.js-product__custom-color-picker').forEach((i) => {
          let slides = i.querySelectorAll('.swiper-slide:not([style*="display: none"])');
          let allowTouchMove = slides.length > 4;
          
          let color_picker_slider = new Swiper (i, {
                      setWrapperSize:true,
                      centeredSlides: false,
                      grabCursor: true,
                      preventClicks: false,
                      preventClicksPropagation: true,
                      preventInteractionOnTransition: true,
                      freeMode:{
                        enabled: true,
                        momentumBounce: false,
                        momentum: false,
                        sticky:false
                      },
                      watchOverflow:false,
                      on: {
                          init: function () {
                          },
                        
                      },
            slidesPerView: 'auto',
            autoHeight: false,
            loop: false,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            },
            
            breakpoints: {
              767: {
                centeredSlides: false,
                width: 250,
                setWrapperSize:true,
                loop: false,
                allowTouchMove: allowTouchMove,
                freeMode:{
                  enabled: true
                },
                scrollbar: {
                  el: '.swiper-scrollbar',
                  draggable: true,
                  enabled:true,
                  hide:false
                },
                navigation: {
                  hide:true,
                  enabled:false,
                }
              }
            }
          });

          if (color_picker_slider) {
            // 
            color_picker_slider.on('sliderMove', function (e) {
              //console.log("on slide tap")
            });
            color_picker_slider.on('tap', function (e) {
              //console.log("on slide tap")
            });
            color_picker_slider.on('touchStart', function (e) {
              //console.log("on slide touchStart")
            });

            // 
            setTimeout(() => {
              const wrapper = color_picker_slider.$wrapperEl?.[0];
              if (!wrapper) return;

              if(color_picker_slider && color_picker_slider.allowTouchMove) {
                color_picker_slider.scrollbar.setTranslate();
                color_picker_slider.scrollbar.updateSize();
                wrapper.classList.remove("blocked")
              } else {
                wrapper.classList.add("blocked")
              }
            }, 600);
          }
        });
      });
    
	},500);
}


_initPickerSlider();



setTimeout(() => {
	$('.js-feature-tab').each(function (index, item) {
		$(item).on('click', () => {
     
			_initPickerSlider();
			_showMore();
		});
	});

	_showMore();

},500);
window.addEventListener('resize', () => {
  // Call the function to initialize or update the Swiper slider
  _initPickerSlider();
});
function _showMore() {
	if (window.innerWidth < 992) {
		let showMoreContainers = document.querySelectorAll('.js-show-more-container');
    if (!showMoreContainers) return;

		let showMoreContainer;
		let showMoreContainerElements;
		let showMoreButton;



		showMoreContainers.forEach((item) => {
			if(!item.classList.contains('hide')) {
				showMoreContainer = item;

				showMoreContainerElements = item.querySelectorAll('.p-custom__color-group:not(.hide-group)');

				showMoreButton = item.querySelector('.js-show-more-button');
				if (showMoreButton && showMoreContainerElements.length <= 3) {
					showMoreButton.remove();
				}
			}
		});

		showMoreContainerElements.forEach((item, index) => {

			if (index < 3) {
				item.classList.remove('hidden');
			}
		})

		let showMore = function () {

			if(showMoreContainer.classList.contains('closed')) {
				showMoreContainerElements.forEach((item) => {
					item.classList.remove('hidden');
				})
				_initPickerSlider();
				showMoreContainer.classList.remove('closed');

			} else {
				showMoreContainerElements.forEach((item, index) => {
					if (index >= 3) {
						item.classList.add('hidden');
					}
				});
				showMoreContainer.classList.add('closed');
			}
		};

		if(showMoreButton && !showMoreButton.classList.contains('is-event')) {
			showMoreButton.classList.add('is-event');
			showMoreButton.addEventListener('click', showMore);
		}
		_initPickerSlider();
	}
}


var ShopifyRoot = window.Shopify.routes.root;


theme.CustomProduct = (function() {

  const selectors = {
    $sidebarCart: '.js-wbsk-sidebar-cart',
    $imageModal: '.p-custom__images-modal',
    $imageModalInner: '.p-custom__images-modal-inner'
  };

  function CustomProduct(container) {
    if (!container) {
      return;
    }

    const self = this;
    this.container = container;

    this.options = {
      namespace: 'customProduct'
    };

    let variants_overlay_image = JSON.parse(document.querySelector('[data-product-variant-overlay-image]')?.textContent);

    this.data = {
      products: theme.customProductParts,
      parentProduct: theme.customProductParts[0],
      selectedVariants: [],
      variantsOverlayImage: variants_overlay_image,
      currentOverlayImage:'',
      currentArtImage:'',
      hideVariantOverlayImage: true,
      hideProductOverlayImage: false,
      selectedSize: false,
      textLines: [],
      currentPrice: 0,
	    customEngravingProductPrice: '',
	    customEngravingProductArtPrice: '',
      hasEngraving: false,
      hasEngravingArt: false,
	    initEngravingArt: false,
      engravingArtImg: '',
      engravingArtId: '',
	    checked: 'checked',
      longestTextLine: 5,
		  firstLoading: 0
    };

    this.methods = {
      setActiveProduct: this._setActiveProduct.bind(this),
      updateSelectedVariant: this._updateSelectedVariant.bind(this),
      addToCart: this._addToCart.bind(this),
      addTextLine: this._addTextLine.bind(this),
      removeTextLine: this._removeTextLine.bind(this),
      updatePrice: this._updatePrice.bind(this),
      personaliseOnKeyUp: this._personaliseOnKeyUp.bind(this),
      personaliseOnClick: this._personaliseOnClick.bind(this),
      openImageModal: this._openImageModal.bind(this),
      closeImageModal: this._closeImageModal.bind(this),
    };

    this.state = {
      ready: false,
      products: {
        active: 0
      },
      selectedVariantsUpdated: 0,
      allSelectedVariantsAvailable: false,
      engravingEnabled: true,
    };

    this.data.textLines.push({ text: '' });

    for (var i = 0; i < this.data.parentProduct.options_with_values.length; i++) {
      if (this.data.parentProduct.options_with_values[i].name.toLowerCase() == 'size') {
        this.data.parentProduct.sizes = this.data.parentProduct.options_with_values[i].values;
        break;
      }
    }

	  if (theme.customEngravingArtProduct) {
			this.data.engravingArtImg = theme.customEngravingArtProduct.variants;
      //console.log("engraving art images", this.data.engravingArtImg)
	  }

	  if (theme.customEngravingProduct) {
		  this.data.customEngravingProductPrice = theme.customEngravingProduct.variants[0].price;
	  }

	if (theme.customEngravingProduct && theme.customEngravingArtProduct && theme.customEngravingArtProduct.id != ''  ) {
		this.data.customEngravingProductArtPrice = theme.customEngravingArtProduct.variants[0].price;
		this.data.initEngravingArt = true;
	}

	if(document.querySelector('.product__custom-label.customize')) {
		document.querySelector('.product__custom-label.customize').addEventListener('click', (e) => {
      if (!e.target.classList.contains('p-custom__info-icon')) {
        if (e.currentTarget.parentElement.classList.contains('open')) {
          e.currentTarget.parentElement.classList.remove('open');
        } else {
          e.currentTarget.parentElement.classList.add('open');
        }
      }
		});
	}

  const accordionLabels = document.querySelectorAll('.product__accordion-item .wbsk-ui-label');
  if (accordionLabels.length) {
    accordionLabels.forEach(label => {
      label.addEventListener('click', (event) => {
        const currentItem = event.currentTarget.parentElement;
        document.querySelectorAll('.product__accordion-item.open').forEach(item => {
          if (item !== currentItem) {
            item.classList.remove('open');
          }
        });
  
        currentItem.classList.toggle('open');
      });
    });
  }


  const editChoice = document.querySelector('.product__sticky-edit');
  if (editChoice) {
    editChoice.addEventListener('click', function() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
  


	setTimeout(() => {
		const size_tab_slider = new Swiper ('.js-size-tabs--product', {
			centeredSlides: false,
			slidesPerView: 5,
			spaceBetween: 8,
			autoHeight: false,
			breakpoints: {
				767: {
					slidesPerView: 4.25
				}
			}
		});

		document.querySelectorAll('.js-size-tabs--product ul li').forEach((item) => {
			item.addEventListener('click', () => {
				_initPickerSlider();
			});
		});

	},500);

    this._cacheSelectors();

    this._formatProductData();

    this._updatePrice();

    this.data.selectedSize = this.data.selectedVariants[0]['option' + this.data.products[0].optionIndex.size];

    this._updateColorAvailability();

    this._updateVariantAvailability();

    this.view = this._bindView();

    // Select initial variants
    var inputEls, inputEl, changeEvent, colourGroupEls = this.container.querySelectorAll('.p-custom__colors');

    this.state.ready = true;

    inputEl = colourGroupEls[0].querySelectorAll('input')[this.data.products[0].firstVariantIndex];
    $(inputEl).click();

    var colorString, colorParts, colorGroup, colorName;
    for (var i = this.data.products.length - 1; i >= 0; i--) {
      colorString = this.data.selectedVariants[i]['option' + this.data.products[i].optionIndex.color];

      if (colorString.indexOf('/') > -1) {
        colorParts = colorString.split('/');
        colorGroup = colorParts[0].trim();
        colorName = colorParts[1].trim();
      } else {
        colorGroup = 'Misc';
        colorName = colorString;
      }

      this.data.products[i].currentColor = colorName;
      this.data.products[i].currentColorString = colorString;
    }

    this.$sidebarCart.on('update', function() {

      var bundleGroupPrices = {},
          bundleGroupParents = {};

      for (var i = 0; i < event.cart.items.length; i++) {
        var lineItem = event.cart.items[i];

        if (lineItem.properties && lineItem.properties._bundleGroup && !lineItem.properties._isEngravingProduct) {
          bundleGroupPrices[lineItem.properties._bundleGroup] = bundleGroupPrices[lineItem.properties._bundleGroup] || 0;
          bundleGroupPrices[lineItem.properties._bundleGroup] += lineItem.line_price;

          if (!lineItem.properties._hide_in_cart) {
            bundleGroupParents[lineItem.properties._bundleGroup] = lineItem.key;
          }
        }
      }

      for (var key in bundleGroupParents) {
        if (bundleGroupParents.hasOwnProperty(key)) {
          $('.a-cart__row[data-id="' + bundleGroupParents[key] + '"] .line_price').html('<span class="money">' + Shopify.formatMoney(bundleGroupPrices[key], window.shopCurrencySymbol + "{{amount}}") + '</span>');
        }
      }

      if (typeof DoublyGlobalCurrency !== 'undefined' && $('[name=doubly-currencies]').length > 0) {
        DoublyGlobalCurrency.convertAll($('[name=doubly-currencies]').val());
      }

      $('.wbsk-cart__item-qty-selector--custom').each(function() {
        var $this = $(this),
            $minus = $('.minus', $this),
            $plus = $('.plus', $this),
            currentCart = event.cart;

        $minus.on('click', function() {
          var $input = $('input', $this),
              qty = parseInt($input.val()) - 1,
              parentLineId = $input.data('id'),
              groupId,
              updates = {};

          for (var i = 0; i < currentCart.items.length; i++) {
            if (currentCart.items[i].key == parentLineId) {
              groupId = currentCart.items[i].properties._bundleGroup;
              updates[currentCart.items[i].key] = qty;
              break;
            }
          }

          for (var i = 0; i < currentCart.items.length; i++) {
            if (currentCart.items[i].key != parentLineId && currentCart.items[i].properties._bundleGroup == groupId) {
              updates[currentCart.items[i].key] = qty;
            }
          }

          $.post(ShopifyRoot+'cart/update.js', {
            updates: updates
          }, function() {
            window.wbskGlobal.sidebarCart.udpate();
          }, 'json');
        });

        $plus.on('click', function() {
          var $input = $('input', $this),
              qty = parseInt($input.val()) + 1,
              parentLineId = $input.data('id'),
              groupId,
              updates = {};

          for (var i = 0; i < currentCart.items.length; i++) {
            if (currentCart.items[i].key == parentLineId) {
              groupId = currentCart.items[i].properties._bundleGroup;
              updates[currentCart.items[i].key] = qty;
              break;
            }
          }

          for (var i = 0; i < currentCart.items.length; i++) {
            if (currentCart.items[i].key != parentLineId && currentCart.items[i].properties._bundleGroup == groupId) {
              updates[currentCart.items[i].key] = qty;
            }
          }

          $.post(ShopifyRoot+'cart/update.js', {
            updates: updates
          }, function() {
            window.wbskGlobal.sidebarCart.udpate();
          }, 'json');
        });
      });
    });
  }

  CustomProduct.prototype = $.extend({}, CustomProduct.prototype, {

    _cacheSelectors: function() {
      var keys = Object.keys(selectors),
          self = this;

      for (var i = 0; i < keys.length; i++) {
        var selector = selectors[keys[i]];
        self[keys[i]] = keys[i].indexOf('$') === 0 ? $(selector) : self.container.querySelector(selector);
      }

    },

    _formatProductData: function() {
      var product, groupName, colorString, colorParts, colorGroup, colorName, firstVariantSku, firstVariantIndex;

      for (var i = 0; i < this.data.products.length; i++) {
        product = this.data.products[i];
        product.colorGroups = {};
        product.optionIndex = {};
        product.colorGroups.groupNames = [];
        firstVariantIndex = 0;
        firstVariantSku = false;
		for (var x = product.tags.length - 1; x >= 0; x--) {
          if (product.tags[x].indexOf('select-first:') > -1) {
            firstVariantSku = product.tags[x].replace('select-first:', '').trim();
            break;
          }
        }

	    if (firstVariantSku) {
          for (var y = 0; y < product.variants.length; y++) {
            if (product.variants[y].sku == firstVariantSku) {
              firstVariantIndex = y;
              break;
            }
          }
        }

        product.firstVariantIndex = firstVariantIndex;

        for (var j = 0; j < product.options_with_values.length; j++) {
          groupName = product.options_with_values[j].name.toLowerCase();

          product.optionIndex[groupName] = product.options_with_values[j].position;

          if (groupName == 'color' || groupName == 'colour') {
            for (var n = 0; n < product.options_with_values[j].values.length; n++) {
              colorString = product.options_with_values[j].values[n];

              if (colorString.indexOf('/') > -1) {
                colorParts = colorString.split('/');
                colorGroup = colorParts[0].trim();
                colorName = colorParts[1].trim();
              } else {
                colorGroup = 'Misc';
                colorName = colorString;
              }

              if (!product.colorGroups[colorGroup]) {
                product.colorGroups[colorGroup] = [];
                product.colorGroups.groupNames.push(colorGroup);
              }

              product.colorGroups[colorGroup].push({
                name: colorName,
                string: colorString,
                available: false
              });

              if (n == 0) {
                product.currentColor = colorName;
                product.currentColorString = colorString;
              }
            }
          }
        }

        if (product.optionIndex.color) {
          product.optionIndex.colour = product.optionIndex.color;
        }

        if (product.optionIndex.colour) {
          product.optionIndex.color = product.optionIndex.colour;
        }

        this.data.selectedVariants.push(_.assignIn({}, product.variants[firstVariantIndex]));
      }

		this._loadingCurrentVariant();
    },

    _bindView: function() {
      return tinybind.bind(this.container, {
        data: this.data,
        methods: this.methods,
        state: this.state
      });
    },

		_personaliseOnClick: function (evt, target) {
			this.data.currentArtImage = target.variant.image;
			this.data.engravingArtId = target.variant.id;

			if ($(evt.target).hasClass('art_selected')) {
				// If it does, remove the class
				$(evt.target).removeClass('art_selected');
				this.data.currentArtImage = '';
				hasEngravingArt = false;
				this.data.hasEngravingArt = false;
				$('.p-custom__image-art-overlay').hide();
				this.data.hideProductOverlayImage = false;
			} else {
				$('.p-custom__personalise-art-buttons button').removeClass('art_selected');
				$(evt.target).addClass('art_selected');
				$('.p-custom__image-art-overlay').show();
				//this._updatePrice(evt, target);
			}
			this._updatePrice(evt, target);
		},

    _personaliseOnKeyUp: function(evt, target) {
      var longestTextLine = 5;
      for (var i = 0; i < this.data.textLines.length; i++) {
        if (this.data.textLines[i].text.length > longestTextLine) {
          longestTextLine = this.data.textLines[i].text.length;
        }
      }

      this.data.longestTextLine = longestTextLine;
      this._updatePrice(evt, target);
    },

    _updatePrice: function(evt, target) {
      var total = 0,
          isEngravingEnabled= true,
				  hasEngraving = false,
				  hasEngravingArt = false,
				  comparePrice,
				  comparePriceTotal = 0;


			var currentColorGroup = this.data.parentProduct.currentColorString.split('/')[0].trim();

      for (var i = 0; i < this.data.selectedVariants.length; i++) {
        total += this.data.selectedVariants[i].price;
        comparePrice = this.data.selectedVariants[i].compare_at_price || this.data.selectedVariants[i].price;
        comparePriceTotal += comparePrice;
          if (this.data.selectedVariants[i].visibility.hide_engraving && this.data.selectedVariants[i].visibility.hide_engraving === 'true') {
              isEngravingEnabled = false;
          }
      }

			if (currentColorGroup && currentColorGroup != 'Limited Edition Artist Designs') {
				if (theme.customEngravingProduct && isEngravingEnabled) {
					for (var i = 0; i < this.data.textLines.length; i++) {
						if (this.data.textLines[i].text != '') {
							hasEngraving = true;
							total += theme.customEngravingProduct.variants[0].price;

							comparePrice = theme.customEngravingProduct.variants[0].compare_at_price || theme.customEngravingProduct.variants[0].price;
							comparePriceTotal += comparePrice;
							break;
						}
					}
				}
			}

			if (theme.customEngravingArtProduct) {
				if (this.data.currentArtImage != '' && isEngravingEnabled) {
					if (currentColorGroup && currentColorGroup != 'Limited Edition Artist Designs') {
						hasEngravingArt = true;
						this.data.hideProductOverlayImage = true;
						total += theme.customEngravingArtProduct.variants[0].price;
						comparePrice = theme.customEngravingArtProduct.variants[0].compare_at_price || theme.customEngravingArtProduct.variants[0].price;
						comparePriceTotal += comparePrice;
					}
				}
			}

      this.data.hasEngraving = hasEngraving;
      this.data.hasEngravingArt = hasEngravingArt;
      this.data.currentPrice = total;

      const productDiscountPercentage = document.getElementById('data-product-discount-percentage');

      if (comparePriceTotal > total) {
        this.data.currentComparePrice = comparePriceTotal;
        let currentComparePrice = this.data.currentComparePrice;
        let currentPrice = this.data.currentPrice;
        if(currentComparePrice && currentPrice){
            let percent = 100 - Math.round(currentPrice / currentComparePrice * 100);
            if (productDiscountPercentage) {
                productDiscountPercentage.textContent = percent;
                productDiscountPercentage.style.display = 'block'
            }
        }
      } else {
        this.data.currentComparePrice = false;
        if (productDiscountPercentage) {
            productDiscountPercentage.style.display = 'none'
         }
      }

      const stickyBarPrice = document.querySelector('.product-sticky-bar__button-total');
      if (stickyBarPrice) {
        if (Shopify.currency && Shopify.currency.active === 'EUR' && (Shopify.country == 'IE' || Shopify.country == 'MT')) {
          stickyBarPrice.textContent = stickyBarPrice.textContent.replace(',', '.');
        }
      }

      setTimeout(function() {
        if (typeof DoublyGlobalCurrency !== 'undefined' && $('[name=doubly-currencies]').length > 0) {
          DoublyGlobalCurrency.convertAll($('[name=doubly-currencies]').val());
        }
      }, 0);
    },

    _setActiveProduct: function(evt, target) {
      this.state.products.active = target.$index;
    },

    _updateSelectedVariant: function (evt, target) {
        var color = target.color,
										size = target.size,
										self = this, parentVariant;

        var color = target.color, size = target.size, self = this, parentVariant;

        const selectedVariant_qty = (selectedVariant) => {
          const stock_block = document.querySelector(".js-product-stock-remaining");
          const stock_fill = document.querySelector(".js-product-stock-remaining-fill");
          const stock_percent = document.querySelector(".js-product-stock-remaining-percent");
          const stock_wrap = document.querySelector(".js-product-details-section");
          setTimeout(function(){
            let qty = selectedVariant.inventory_quantity;
            if (qty < 101 && qty > 0) {
              stock_wrap.classList.add("show-stock-remaining");
              stock_block.classList.remove('hide');
              stock_block.style.opacity = '1';
              stock_fill.style.width = `${qty}%`;
              stock_percent.innerHTML = `${qty}`;
            } else {
              stock_wrap.classList.remove("show-stock-remaining");
              stock_block.classList.add('hide');
              stock_block.style.opacity = '0';
              stock_fill.style.width = `100%`;
              stock_percent.innerHTML = ``;
            }
          },300);
        };
        
        if (color) {
            var product = target.$parent.$parent.product,
								index = target.$parent.$parent.$index;
            var selectedVariant,
								colorString = color.string,
								colorGroup = target.$parent.group;

            product.currentColor = color.name;
            product.currentColorString = colorString;

            var regex = new RegExp(colorString, 'g');

            selectedVariant = _.find(product.variants, function(variant) {
                return variant['option' + product.optionIndex.color].match(regex) && variant['option' + product.optionIndex.size] == self.data.selectedVariants[index]['option' + product.optionIndex.size];
            });

            if (selectedVariant) {
            // console.info('Selected variant:', selectedVariant);
                selectedVariant_qty(this.data.selectedVariants[0]);
                _.each(_.keys(selectedVariant), function(key){ self.data.selectedVariants[index][key] = selectedVariant[key]; });
                let current_variant_id = this.data.selectedVariants[0].id;
                let current_variant_OverlayImage = this.data.variantsOverlayImage.variants[`${current_variant_id}`];

								if(current_variant_OverlayImage){
									this.data.currentOverlayImage = `https://www.shoreusable.com/cdn/shop/files/${current_variant_OverlayImage}.png?v=1642171341`;
									this.data.hideVariantOverlayImage = false;
									this.data.hideProductOverlayImage = true;
								}
								else {
									this.data.hideVariantOverlayImage = true;
									this.data.hideProductOverlayImage = false;
								}

                if (selectedVariant.custom.connected_parts) {
                    parentVariant = selectedVariant;
                }
            }
        }

      if (size) {
        const minicartUpsellSelect = document.querySelector(".js-minicart-upsell-select");
        selectedVariant_qty(this.data.selectedVariants[0]);

        if (minicartUpsellSelect) {
            const upsellOption = [...minicartUpsellSelect.options].filter(element => {
              const optionSize = element.getAttribute("data-option-size");

              if (optionSize === size) {
                return element;
              }
            });

            if (upsellOption.length) {
              const selectedUpsellOption = upsellOption[0];
              //console.log("selectedUpsellOption: ", selectedUpsellOption);
              selectedUpsellOption.selected = "selected";
              const imageUrl = selectedUpsellOption.getAttribute("data-image");
              const form = selectedUpsellOption.closest("form");
              const image = form.querySelector("img");
              image.setAttribute("src", imageUrl);
            }
        }

        for (var i = 0; i < this.data.products.length; i++) {
                var product = this.data.products[i],
                currentVariant = this.data.selectedVariants[i];

            if (product.optionIndex.size) {
                selectedVariant = _.find(product.variants, function(variant) {
                    return variant['option' + product.optionIndex.size] == size && variant['option' + product.optionIndex.color] == currentVariant['option' + product.optionIndex.color];
                });

                if (!selectedVariant) {
                    selectedVariant = _.find(product.variants, function(variant) {
                        return variant['option' + product.optionIndex.size] == size;
                    });
                }

                // console.info('Selected variant:', selectedVariant);
                if (selectedVariant) {
                    _.each(_.keys(selectedVariant), function(key){ self.data.selectedVariants[i][key] = selectedVariant[key]; });

                    if (selectedVariant.custom.connected_parts) {
                        parentVariant = selectedVariant;
                    }
                }
            }
        }

        this._updateColorAvailability();
      }

      // Select connected variants
      if (parentVariant) {
        var variantParts = parentVariant.custom.connected_parts.split('|'), productHandle, variantId, connectedVariant;

        for (var i = variantParts.length - 1; i >= 0; i--) {
          variantInfo = variantParts[i].split(':');
          productHandle = variantInfo[0];
          variantId = parseInt(variantInfo[1]);

          for (var n = this.data.products.length - 1; n >= 0; n--) {
            if (this.data.products[n].handle == productHandle) {
              connectedVariant = _.find(this.data.products[n].variants, function(variant) {
                return variant.id == variantId;
              });

              if (connectedVariant) {
                _.each(_.keys(connectedVariant), function(key){ self.data.selectedVariants[n][key] = connectedVariant[key]; });
              }
            }
          }
        }
      }

      var substitutePart;
      for (var i = 0; i < self.data.selectedVariants.length; i++) {
        if (self.data.selectedVariants[i].custom.substitute_from) {
          for (var n = 0; n < self.data.selectedVariants[i].custom.substitute_from.length; n++) {
            substituteFrom = self.data.selectedVariants[i].custom.substitute_from[n].split(':');
            substituteTo = self.data.selectedVariants[i].custom.substitute_to[n].split(':');

            if (substituteFrom && substituteTo) {
              substituteFromHandle = substituteFrom[0];
              substituteFromId = parseInt(substituteFrom[1]);

              substituteToHandle = substituteTo[0];
              substituteToId = parseInt(substituteTo[1]);

              for (var j = 0; j < self.data.selectedVariants.length; j++) {
                if (self.data.selectedVariants[j].id == substituteFromId) {
                  substitutePart = _.find(self.data.products[j].variants, function(variant) {
                    return variant.id == substituteToId;
                  });

                  if (substitutePart) {
                    _.each(_.keys(substitutePart), function(key){ self.data.selectedVariants[j][key] = substitutePart[key]; });
                  }
                  break;
                }
              }
              break;
            }

          }
        }
      }

      if (size) {
        var colorString, colorParts, colorGroup, colorName;
        for (var i = this.data.products.length - 1; i >= 0; i--) {
          colorString = this.data.selectedVariants[i]['option' + this.data.products[i].optionIndex.color];

          if (colorString.indexOf('/') > -1) {
            colorParts = colorString.split('/');
            colorGroup = colorParts[0].trim();
            colorName = colorParts[1].trim();
          } else {
            colorGroup = 'Misc';
            colorName = colorString;
          }

          this.data.products[i].currentColor = colorName;
          this.data.products[i].currentColorString = colorString;
        }
      }

      this.state.selectedVariantsUpdated++;

      this._updateVariantAvailability();

      this._updatePrice();

      var engravingEnabled = true;

      for (var i = 0; i < this.data.selectedVariants.length; i++) {
        if (this.data.selectedVariants[i].visibility.hide_engraving && this.data.selectedVariants[i].visibility.hide_engraving == 'true') {
          engravingEnabled = false;
          break;
        }
      }

      this.state.engravingEnabled = engravingEnabled;

      if(!this.state.engravingEnabled){
        $('.p-custom__image-art-overlay').hide();
        $(".p-custom__image-text-overlay").hide();
      }else{
        $('.p-custom__image-art-overlay').show();
        $(".p-custom__image-text-overlay").show();
      }
      if (!event.detail || !event.detail.force) {
        if (target && target.color) {
          var inputEl,
							changeEvent,
							colourGroupEls = this.container.querySelectorAll('.p-custom__colors');

          for (var i = 0; i < colourGroupEls.length; i++) {
            if (index != i) {
              inputEl = colourGroupEls[i].querySelector('input[data-checked="true"]');
              if (inputEl) {
               
                // inputEl.checked = true;
                changeEvent = new Event('change');
                changeEvent.detail = {
                  'force': true
                };
                inputEl.dispatchEvent(changeEvent);
              }
            }
          }

          inputEl = colourGroupEls[index].querySelector('input[data-checked="true"]');
          // inputEl.checked = true;
          changeEvent = new Event('change');
          changeEvent.detail = {
            'force': true,
          };
         
          inputEl.dispatchEvent(changeEvent);
        }
      }
    },

		_updateVariantAvailability: function() {
			var allVariantsAvailable = true;
			for (var i = 0; i < this.data.selectedVariants.length; i++) {
				if (!this.data.selectedVariants[i].available) {
					allVariantsAvailable = false;
					break;
				}
			}

			this.state.allSelectedVariantsAvailable = allVariantsAvailable;

      const stockNotification = $('.stock-notification');

      if (stockNotification.length) {
        const textEl = stockNotification.find('.stock-notification__text');
      
        if (allVariantsAvailable) {
          const data = stockNotification.data('true');
          stockNotification
            .addClass('product__in-stock')
            .removeClass('product__of-stock');
          textEl.text(data);
        } else {
          const data = stockNotification.data('false');
          stockNotification
            .removeClass('product__in-stock')
            .addClass('product__of-stock');
          textEl.text('');
        }
      }

      this._updateVariantUrl();
		},

    _updateColorAvailability: function() {
      var keys, size, color, selectedVariant, product, groupEmpty = true;

      size = this.data.selectedSize;
      let current_variant_id = this.data.selectedVariants[0].id;
      let current_variant_OverlayImage = this.data.variantsOverlayImage.variants[`${current_variant_id}`];

      if(current_variant_OverlayImage){
        this.data.currentOverlayImage = `https://www.shoreusable.com/cdn/shop/files/${current_variant_OverlayImage}.png?v=1642171341`;
        this.data.hideVariantOverlayImage = false;
        this.data.hideProductOverlayImage = true;
      } else {

        this.data.hideVariantOverlayImage = true;
        this.data.hideProductOverlayImage = false;
      }

      this.data.currentOverlayImage = this.data.currentOverlayImage;
      for (var i = 0; i < this.data.products.length; i++) {
        keys = Object.keys(this.data.products[i].colorGroups);
        for (var j = 0; j < keys.length; j++) {
          if (keys[j] != 'groupNames' && keys[j] != 'hide') {
            for (var n = 0; n < this.data.products[i].colorGroups[keys[j]].length; n++) {
              color = this.data.products[i].colorGroups[keys[j]][n];
              product = this.data.products[i];
              selectedVariant = _.find(product.variants, function (variant) {
                return (variant['option' + product.optionIndex.size] == size && variant['option' + product.optionIndex.color] == color.string);
              });

              color.variantId = '';

              if (!selectedVariant || !selectedVariant.available || selectedVariant.visibility.hide_on_custom == 'true') {
                color.available = false;

                if (selectedVariant && selectedVariant.visibility.hide_on_custom == 'true') {
                  color.hide = true;
                } else {
                  if (selectedVariant) {
                    groupEmpty = false;
                  } else {
                    color.hide = true;
                  }
                }
              } else {
                color.available = true;
                color.hide = false;
                groupEmpty = false;
                color.variantId = selectedVariant.id;
              }

              if (!selectedVariant) {
                color.hideOption = true;
              }
              else if (selectedVariant?.visibility.hide_in_the_list_of_lids == 'true') {
                color.hideOption = true;
              }
              else {
                if (!selectedVariant.available && !(selectedVariant.inventory_policy === "continue")) {
                  color.hideOption = true;
                }
                color.hideOption = false;
              }
            }

            for (let t of this.data.products[i].colorGroups[keys[j]] ) {
              if(t.hideOption == false) {
                this.data.products[i].colorGroups[keys[j]].hideOption = false;
                break;
              } else {
                this.data.products[i].colorGroups[keys[j]].hideOption = true;
              }
            }

            this.data.products[i].colorGroups[keys[j]].hide = groupEmpty;
            groupEmpty = true;
          }
        }
      }
    },

    _openImageModal: function() {
      this.$imageModalInner.html($('.p-custom__images')[0].outerHTML);
      this.$imageModal.addClass('active');
    },

    _closeImageModal: function() {
      this.$imageModal.removeClass('active');
    },

    _addTextLine: function() {
      if (this.data.textLines.length < 5) {
        this.data.textLines.push({ text: '' });
      }

      $('.p-custom__personalise-inputs input').last().focus();
    },

    _removeTextLine: function() {
      if (this.data.textLines.length > 1) {
        this.data.textLines.pop();
      }

      $('.p-custom__personalise-inputs input').last().focus();
    },

    _clearTextLines: function() {
      while (this.data.textLines.length > 0) {
        this.data.textLines.pop();
      }

      this.data.textLines.push({ text: '' });
    },

    _addToCart: function(evt, target) {
      var data = { items: [] },
          lineItem,
          timestamp = Date.now(),
          properties = { '_bundleGroup': timestamp };

      for (var i = 0; i < this.data.selectedVariants.length; i++) {

        if (this.data.selectedVariants[i].price == 0 && this.data.selectedVariants[i].title.toLowerCase().indexOf('none') > -1) {
          continue;
        }

        var variantId = this.data.selectedVariants[i].id;
        if (this.data.selectedVariants[i].custom.variant_to_add) {
          variantId = parseInt(this.data.selectedVariants[i].custom.variant_to_add.split(':')[1]);
        }

        lineItem = {
          quantity: 1,
          id: variantId
        };

        if (i != 0) {
          properties['_part_product_' + i] = this.data.selectedVariants[i]['option' + this.data.products[i].optionIndex.color];
          properties['_part_product_image_' + i] = theme.Image.getSizedImageUrl(this.data.selectedVariants[i].image, '128x');
          lineItem.properties = { '_hide_in_cart': true, '_bundleGroup': timestamp };
        }

        if (this.data.selectedVariants[i].custom.prevent_atc && this.data.selectedVariants[i].custom.prevent_atc == 'true') {
          continue;
        }

        data.items.push(lineItem);
      }

      data.items[0].properties = properties;

      for (var n = 0; n < this.data.products[0].tags.length; n++) {
        if (this.data.products[0].tags[n].indexOf('preorder:') == 0) {
          var preorderString = this.data.products[0].tags[n].replace('preorder:', '').trim();
          data.items[0].properties['Preorder'] = preorderString;
        }
      }

      // Engraving
      if (this.state.engravingEnabled && theme.customEngravingProduct && this.data.hasEngraving) {
        lineItem = {
          quantity: 1,
          id: theme.customEngravingProduct.variants[0].id
        };

        properties = {...properties, '_isEngravingProduct': true };

        for (var i = 0; i < this.data.textLines.length; i++) {
          if (this.data.textLines[i].text != '') {
            properties['line' + (i + 1)] = this.data.textLines[i].text;
          }
        }

        lineItem.properties = properties;

        data.items.push(lineItem);

        this._clearTextLines();
      }

      // EngravingArt
	  	//console.log("engraving", this.data.hasEngravingArt , this.state.engravingEnabled, theme.customEngravingProduct);
	  	if (this.state.engravingEnabled && theme.customEngravingProduct && this.data.hasEngravingArt) {
			lineItem = {
				quantity: 1,
				id: this.data.engravingArtId
			};


			properties = { '_isEngravingProduct': true };

			for (var i = 0; i < this.data.textLines.length; i++) {
				if (this.data.textLines[i].text != '') {
					properties['line' + (i + 1)] = this.data.textLines[i].text;
				}
			}
			lineItem.properties = properties;
			data.items.push(lineItem);

		}

      header_slideouts.open('cart');

      $.post(ShopifyRoot+'cart/add.js', data, function() {
        window.wbskGlobal.sidebarCart.udpate();
      }, 'json');
    },

    // Loading current variant and accessories from custom URL
    _loadingCurrentVariant: function () {
      let self = this;
      const firstOption = `.product__custom-radio-input[value="${this.data.products[0].selected_variant_option}"]`,
        targetNode = document.getElementById('js-product-form'),
        config = { attributes: true, childList: true, subtree: true };

      const callback = (mutationList, observer) => {
        let mainVariant = document.querySelector(firstOption);
        if (mainVariant) {
          self._updateMainVariant(mainVariant);
          observer.disconnect();
        }
      };

      const observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
    },

  	_updateMainVariant: function (variantSelect) {
		let self = this;
		let selectors = {
			variants: 'input[data-for-variant]',
			variantsAttr: 'data-for-variant'
		};

		variantSelect.parentNode.click();
		variantSelect.click();
		let inputs = document.querySelectorAll(selectors.variants);
		if (inputs.length) {
			for (let i = 0; inputs.length > i ; i++) {
				if (inputs[i].getAttribute(selectors.variantsAttr) == self.data.products[0].selected_variant_id) {
                    inputs[i].checked = true;
					inputs[i].click();
					break;
				}
			}

			self._updateAccessories();

		} else {
			self._removeLoader();
		}
	  },

	  _updateAccessories: function () {
		setTimeout(()=> {
			let urlParams = new URLSearchParams(window.location.search);
			const selectors = document.querySelectorAll('input[data-for-variant]');
			urlParams.forEach((value, key) => {
				if (key.includes('a-id') && selectors.length) {
					for (let i = 0; selectors.length > i ; i++) {
						if (selectors[i].getAttribute('data-for-variant') == value) {
							selectors[i].click();
							break;
						}
					}
				}
			});
			this._removeLoader();
		},500);
	  },

	  _removeLoader: function () {
      setTimeout(() => {
        document.getElementById('js-main-gallery').classList.remove('loader');
      }, 500);

      this.data.firstLoading = 1;
  	},

    _updateVariantUrl: function() {
      const mainProductSelectedVariant = this.data.selectedVariants[0];
      const newUrl = new URL(window.location);
      if (mainProductSelectedVariant) {
        newUrl.searchParams.set('variant', mainProductSelectedVariant.id);
      }

      if (this.data.firstLoading) {
        for (let i = 1; this.data.selectedVariants.length > i; i++ ) {
          if (this.data.selectedVariants[i]) {
            newUrl.searchParams.set(`a-id${i}`, this.data.selectedVariants[i].id);
          }
        }
      }

      window.history.replaceState({path: newUrl.href}, '', newUrl.href);
          // console.log("variant select 1 ", mainProductSelectedVariant.id)
          // custom slider on change
          var swiperInstance = window.mySwiper;
          var swiperInstanceThumb = window.mySwiperThumbs;
          var data = theme.customProductParts[0];
          // Filter the variants object based on selected_variant_id
          const filteredVariant = data.variants.find(variant => variant.id === mainProductSelectedVariant.id);

          // Get the variant_images array from the filtered variant
          const variantImages = filteredVariant ? filteredVariant.variant_images : [];
          //mobile slider
          const numberOfSlides = swiperInstance.slides.length;
          // console.log("swiper slider desktop: ",numberOfSlides , variantImages)
          const indicesToRemove = [];
          for (let i = 1; i < numberOfSlides; i++) {
            indicesToRemove.push(i);
          }
          indicesToRemove.forEach(index => {
            const slide = swiperInstance.slides[index];
            if (slide) {
              slide.classList.add('hidden');
            }
          });

        //thumbs slider
        const numberOfSlides_thumb = swiperInstanceThumb.slides.length;
        //console.log("swiper slider desktop Thumb: ",numberOfSlides_thumb , variantImages)
        const indicesToRemoveThumb = [];
          for (let i = 1; i < numberOfSlides_thumb; i++) {
            indicesToRemove.push(i);
          }
          indicesToRemoveThumb.forEach(index => {
            const slide = swiperInstanceThumb.slides[index];
            if (slide) {
              slide.classList.add('hidden');
            }
          });
          swiperInstanceThumb.removeSlide(indicesToRemove);
          // Remove the slides

      variantImages.forEach((image, index) => {
            const slideContent = `<li class="block-12/12 swiper-slide js-psp_product variant_images">
                    <img class=" block-12/12" alt="" data-src="${image.image_src}" src="${image.image_src}"  data-srcset="${image.image_src}" data-var_id="46313318678836">
                    </li>`;
          swiperInstance.addSlide(1, slideContent);
          swiperInstanceThumb.addSlide(1, slideContent);
      });

        // Update the Swiper instance
        const numberOfSlides2 = variantImages.length;
        document.querySelector('.total-slides').innerHTML = numberOfSlides2 + 1;
        swiperInstance.update();
        swiperInstanceThumb.update();

        swiperInstance.slideTo(0, 0);
        swiperInstanceThumb.slideTo(0, 0);
    },

    _accordion: function() {
    }

  });

  return CustomProduct;
})();

$(document).ready(function() {
  var customProductContainer = document.querySelector('.p-main--custom');
  if ('tinybind' in window && customProductContainer) {
    theme.customProduct = new theme.CustomProduct(customProductContainer);
  }

  $(document).on('input', '.p-custom__personalise-inputs input', function(){
    const $input = $(this);
    const max = 10;
    if ($input.val().length > max) {
        $input.val($input.val().substr(0, max));
    }
  });
  const isAndroid = /Android/.test(navigator.userAgent);

  if (isAndroid) {
    console.log("This device is running on Android.");
    $('.product__custom-color-picker-block li .wbsk-ui-radio input').css('z-index', 'unset');
  } else {
    console.log("This device is not running on Android.");
  }
  $('.wbsk-ui-radio--color-tab').on('click', function(event){
    // console.log("on click variant:");
    //$('.js-product_imgs--custom').removeAllSlides();
    // Find the input element within the clicked div
    const $input = $(this).find('input');

    // Check the found input
    $input.prop('checked', true);
	  let firstThumbsItem = document.querySelectorAll('.js-product_thumbs .swiper-wrapper .swiper-slide img');
	  let firstThumbsItemImage = $(firstThumbsItem > 'img');

    let timesRun = 0;
    // let interval = setInterval(function(){
    //   timesRun += 1;
    //   if(timesRun === 10){
		//   clearInterval(interval);
    //   }

    //   $('[data-preview-image]').each(function(){
    //     if (!$(this).attr('src')) {
    //       $(this).hide();

    //     } else {
    //       $(this).show();

    //     }
    //   });


    // }, 100);
    // $('[data-product-discount]').hide();
    // setTimeout(()=>{
    //   let compare = $('[data-product="compare_at_price"] .money').text();
    //   let price = $('.product-sticky-bar__price .money').text();
    //   if(compare && price){
    //     compare = +compare.replace("£", '')
    //     price = +price.replace("£", '');
    //     let percent = 100 - Math.round(price / compare * 100);
    //     $('[data-product-discount] .percents').text(percent);
    //     $('[data-product-discount]').show();
    //   }
    // }, 1000);

  });



// Product Cards handler for selection size/color
 var productCards = document.querySelectorAll('.product-card');

	productCards.forEach( card => {
		let cardSizes = card.querySelector('.product-card__size-selection');
		let cardColorSet = card.querySelectorAll('.product-card__colors-block');

		if (!cardSizes){
			return
		}

  		cardSizes.addEventListener('change', function(){

				let i = 0;
				let shouldSkip = false;
				let selCardSize = cardSizes.value;

			cardColorSet.forEach( (cardColor) => {

				cardColor.setAttribute('hidden', "");

				if (shouldSkip) {
					return;
				}

				let cardColorSize = cardColor.dataset.variantSize;

				if (selCardSize == cardColorSize) {
					cardColor.removeAttribute('hidden');
					i++;

					if (i == 12){
						shouldSkip = true;
						return;
					}
				}

			});

		});

	});

  const icons = document.querySelectorAll('.p-custom__info-icon')

  for(const icon of icons) {
    const box = icon.nextElementSibling;
    icon.addEventListener('click', () => {
      // Toggle the visibility and apply styles
      box.classList.toggle('show');
  
      if (window.innerWidth > 767) {
        // Automatically hide the box after 3 seconds
        setTimeout(function () {
          box.classList.remove('show');
        }, 3000); // 3000 milliseconds
      }
  
    });
  }

});
